'use client';

interface MenuCategoryProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function MenuCategory({
  categories,
  activeCategory,
  onCategoryChange,
}: MenuCategoryProps) {
  return (
    <div className="w-full overflow-x-auto no-scrollbar">
      <div className="flex gap-4 pb-4 min-w-max px-6 lg:px-0">
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => onCategoryChange(category)}
            className={`px-8 py-3 rounded-full text-sm font-bold uppercase tracking-wider whitespace-nowrap transition-all ${
              activeCategory === category
                ? 'bg-primary text-primary-foreground shadow-lg scale-105'
                : 'bg-accent text-accent-foreground hover:bg-primary/10 hover:text-primary'
            }`}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
}